// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2-rCI","alertIcon":"ConfirmModal_alertIcon__3hwXR"};